import axios from 'axios';
import Common from './Common';
export default {
    // getAll() {
    //     return axios.get(Common.api + 'seller-login');
    // },
    getImage() {
        return axios.get(Common.api + 'top-slider');
    },
    create(data) {
        return axios.post(Common.api + 'upload-product', data);
    },
    // createResgistration1(data) {
    //     return axios.post(Common.api + 'seller-reg-first', data);
    // },
    // createResgistration2(data) {
    //     return axios.post(Common.api + 'seller-reg-second', data);
    // },
    update(id, data) {
        return axios.put(Common.api + 'seller-login' + id, data);
    }
}